module.exports = __webpack_public_path__ + "img/topTitle.fb1abff9.png";